export const sectors = {
  edu: 'Education',
  hsc_child: "H & SC Children's",
  hsc_adult: "H & SC Adult's",
  anz_edu: 'Education',
  anz_ss: 'Social Services',
  anz_health: 'Health',
  other: 'Other',
} as const
